import React from "react"
import styled from "styled-components"
import theme from "../../../styles/theme"
import headingStyles from "./headingStyles"

const { colors, breakPoints: { screenQuery } } = theme

const H5 = styled.h5(headingStyles, `
  font-size: 22px;
  line-height: 24px;
  ${screenQuery.large}{
    font-size: 20px;
    line-height: 22px;
  }
  ${screenQuery.small}{
    font-size: 18px;
      line-height: 20px;
  }
`)

export default ({
  children,
  ...props
}) => (
    <H5
      {...props}
    >
      {children}
    </H5>
  )
